import { BUTTON_SIZES, PrimaryButton } from 'ui/button';
import { AddNew24 } from 'ui/icons/aurora/24px/AddNew24';
import { useDataSyncTranslations } from 'modules/dataSync/hooks/useDataSyncTranslations';
import { useDestinationTable, usePrequelContext } from 'modules/dataSync/contexts';
import { StyledMenu, StyledPageHeader } from './DataSyncIndexHeader.styles';
import { FlexSpacer } from 'ui/flexSpacer';
import { InputSearch } from 'ui/inputs';
import { pxToRem } from 'utils/convert';
import { FilterMenuTriggerButton } from 'ui/indexPages/filters/FilterMenuTriggerButton';
import { useMemo } from 'react';
import { getDestinationTableFilterMenu } from 'modules/dataSync/utils';

export const DataSyncIndexHeader = () => {
  const { t } = useDataSyncTranslations();
  const { toggleIsModalShown } = usePrequelContext();
  const { filters, rawDestinations, searchQuery, toggleFilter, setSearchQuery } =
    useDestinationTable();
  const filterOptions = useMemo(() => getDestinationTableFilterMenu(t), [t]);

  // Calculate selected filter count based on filters array
  const selectedFilterCount = filters.length;

  return (
    <StyledPageHeader
      data-test="data-sync-index-page-header"
      pageActions={
        <FlexSpacer gap="half" alignItems="center">
          <StyledMenu
            data-test="data-sync-index-page-header-filter-menu"
            data-style-id="filter-menu"
            isSelectMenu
            isDisabled={!rawDestinations.length}
            defaultSelectedOptionIds={filters}
            handleSelectionChange={toggleFilter}
            options={filterOptions}
          >
            <FilterMenuTriggerButton selectedFilterCount={selectedFilterCount} />
          </StyledMenu>
          <InputSearch
            id="data-sync-search-input"
            placeholder={t('header.searchPlaceholder')}
            width={pxToRem(260)}
            value={searchQuery}
            onChange={setSearchQuery}
            isDisabled={!rawDestinations.length}
          />
          <PrimaryButton
            data-test="data-sync-add-destination-button"
            size={BUTTON_SIZES.LARGE}
            onClick={toggleIsModalShown}
          >
            <AddNew24 />
            {t('header.newDestination')}
          </PrimaryButton>
        </FlexSpacer>
      }
    >
      {t('header.dataSync')}
    </StyledPageHeader>
  );
};
